let FormSubmissions = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.markSynced();
    },

    markSynced () {
        let _this = this;

        $(document).on('click', '.btn-mark-synced', function () {
            const id = $(this).data('id');
            const type = $(this).data('type');

            swal({
                title: "Mark submission as Synced?",
                text: "The submission has failed to sync to Salesforce because a similar contact already exists. You must manually add this contact in Salesforce marking this record as synced.",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, mark it synced!"
            }).then((result) => {
                if (result.value) {
                    $.post('/form-submissions/mark-synced',
                        {
                            id,
                            type
                        },
                        (result) => {
                            if (result.success) {
                                swal(
                                    'Synced!',
                                    'Record has been marked as synced.',
                                    'success'
                                ).then((result) => {
                                    window.location.reload()
                                });
                            }
                        });
                }
            });
        });
    },
};

$().ready(function () {
    window.FormSubmissions = FormSubmissions;
    window.FormSubmissions.init();
});
